import React from 'react';

import { DonationMethod, DonationType } from '../../../types/__generated__';
import { useProduct } from '../../hooks/page/product/useProduct';
import WrappedDonationSummary, { DonationField } from './DonationSummary';

export function DonationSummary() {
  const {
    data: { allowedDonationTypes, allowedDonationMethods },
  } = useProduct();

  const fieldsToShow = Object.values(DonationField).filter(field => {
    switch (field) {
      case DonationField.OnlineAmount: {
        return allowedDonationTypes.includes(DonationType.Online);
      }
      case DonationField.OfflineAmount: {
        return allowedDonationTypes.includes(DonationType.Offline);
      }
      case DonationField.FundraiserRaisedAmount: {
        return (
          allowedDonationTypes.includes(DonationType.Online) &&
          allowedDonationMethods.includes(DonationMethod.Children)
        );
      }
      case DonationField.TextDonations: {
        return (
          allowedDonationTypes.includes(DonationType.Offline) &&
          allowedDonationMethods.includes(DonationMethod.Text)
        );
      }
      case DonationField.DirectDonationAmount: {
        return (
          allowedDonationTypes.includes(DonationType.Online) &&
          allowedDonationMethods.includes(DonationMethod.Direct) &&
          allowedDonationMethods.includes(DonationMethod.Children)
        );
      }
      default:
        return false;
    }
  });

  return <WrappedDonationSummary fieldsToShow={fieldsToShow} />;
}
